<template>
  <div class="main">
    <div class="scroll-box" ref="scrollBox">
      <steps :stepNum="stepNum" />
      <main class="content">
        <div class="step1" v-show="stepNum === 1">
          <basic-info ref="basicInfoRef" v-model="basicInfoForm" />
          <template v-for="comItem in comList">
            <component 
              :is="dynamicComs[comItem.comType]" 
              :key="comItem.comId" 
              :isHasSignUp="isHasSignUp"
              :basicInfoForm="basicInfoForm"
              :isClone="isClone"
              v-model="comItem.formData"
              @changFoot="changFoot" 
              :ref="comItem.comType"
            >
            </component>
          </template>
        </div>
        <div class="step2" v-show="stepNum === 2">
          <poster-conf v-model="otherForm.poster"/>
          <sign-up-conf v-if="isHasSignUp" v-model="otherForm.signUpConf" />
          <lottery-conf 
            v-if="isHaslottery" 
            :isHasSignUp="isHasSignUp" 
            :isHasreserve="isHasreserve"
            :basicInfoForm="basicInfoForm"
            v-model="otherForm.luckDraw"
            ref="lotteryConfRef"
          />
          <spike-conf v-if="isSpike" v-model="otherForm.spikeConf" />
          <introduction-conf v-model="otherForm.introduction" />
          <red-packet-conf ref="redPacketRef" v-model="additionalForm.redPacket" />
          <fission-commission v-model="additionalForm.fission" />
          <ranklist-conf ref="rankListRef" :rankData.sync="rankData" v-model="additionalForm.ranklist" />
        </div>
      </main>
    </div>
    
    <div class="footer" v-if="isFooter">
      <template v-if="stepNum === 1">
        <div class="footer-btn plain" @click="saveActivity(1)">保存</div>
        <div class="footer-btn" @click="nextStep">下一步</div>
      </template>
      <template v-else>
        <div class="footer-btn plain footer-btn-s" @click="preStep">上一步</div>
        <div class="footer-btn plain footer-btn-s" @click="saveActivity(1)">保存</div>
        <div class="footer-btn plain footer-btn-s" @click="preview">预览</div>
        <div class="footer-btn footer-btn-s" @click="saveActivity(2)">发起活动</div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Steps from './steps'
import BasicInfo from './basic-info'
import TopImage from './top-image'
import SignUp from './sign-up'
import Attention from './attention'
import ImageVideo from './image-video'
import PosterConf from './poster-conf'
import SignUpConf from './sign-up-conf'
import IntroductionConf from './introduction-conf'
import RedPacketConf from './red-packet-conf'
import Lottery from './lottery'
import LotteryConf from './lottery-conf'
import LiveReserve from './live-reserve'
import FissionCommission from './fission-commission'
import ranklistConf from './ranklist-conf'
import Question from './question'
import Spike  from './spike'
import spikeConf from './spike-conf'
import ConnectPic from './connect-pic'
import GroupBuy from './group-buy'
import drawLots from './drawLots'
import styleTest from './style-test'
import countMoney from './count-money'
import coupon from './coupon.vue'

import dayjs from "@/utils/dayjs";
import _ from 'loadsh'
import redPackMixin from '../mixins/red-packet'
import loadingMixin from '@/mixins/loading-mixin'
import {isString} from '@/utils/utils'
import {wxPay} from '@/utils/wxPay'

import { 
    luckDrawData,
    formValidation,
    getFissionDTO,
    initFissionForm,
    formatDataLottery,
    paramesVerification,
    initspikeData,
    spikeTimeVerification,
    connectPicVerification,
    initGroupBuyingData,
  } 
from '../utils'
export default {
  name: 'ActivityEditMain',
  components: {
    Steps,
    BasicInfo,
    TopImage,
    SignUp,
    Attention,
    ImageVideo,
    PosterConf,
    SignUpConf,
    IntroductionConf,
    RedPacketConf,
    Lottery,
    LotteryConf,
    LiveReserve,
    FissionCommission,
    ranklistConf,
    Question,
    Spike,
    spikeConf,
    ConnectPic,
    GroupBuy,
    drawLots,
    styleTest,
    countMoney,
    coupon
  },
  mixins: [redPackMixin, loadingMixin],
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
      // 用户信息
      userInfo: 'userInfo'
    }),
    // 是否有报名项目
    isHasSignUp() {
      return this.comList.some(item => item.comType === 'sign-up');
    },
    // 是否有抽奖项目
    isHaslottery() {
      return this.comList.some(item => item.comType === 'lottery');
    },
    // 是否有直播项目
    isHasreserve() {
      return this.comList.some(item => item.comType === 'live-reserve');
    },
    // 是否有问答组件
    isQuestion() {
      return this.comList.some(item => item.comType === 'question');
    },
    // 是否有秒杀组件
    isSpike() {
      return this.comList.some(item => item.comType === 'spike');
    },
    // 是否有拼图组件
    isConnectPic() {
      return this.comList.some(item => item.comType === 'connectPic');
    },
    // 是否有拼团组件
    isGroupBuying() {
      return this.comList.some(item => item.comType === 'groupBuying');
    },
    // 是否有求签组件
    isDrawLots() {
      return this.comList.some(item => item.comType === 'drawLots');
    },
    is365() {
      return this.$cache.is365()
    }
    // isClone() {
    //   return this.$route.query.from == 'clone';
    // }
  },
  data() {
    return {
      isClone: this.$route.query.from == 'clone',
      stepNum: 1,
      dynamicComs: {
        picture: TopImage,
        'sign-up': SignUp,
        'image-text-detail': ImageVideo,
        attention: Attention,
        'lottery': Lottery,
        'live-reserve': LiveReserve,
        'question': Question,
        'spike': Spike,
        'connectPic': ConnectPic,
        'groupBuying': GroupBuy,
        'drawLots': drawLots,
        'style': styleTest,
        'countMoney': countMoney,
        'coupon': coupon
      },
      basicInfoForm: {
        activityTitle: '',
        startTime: '',
        endTime: ''
      },
      // 其他配置类
      otherForm: {
        poster: [],
        introduction: {
          boolShowIntro: false
        },
        luckDraw: {
          everyOneMaxWinCount: '1',
          everyDaySendType: 'everyDay',
          everyDaySendCount: '1',

          boolNewPeopleSendCount: false,
          everyTimeNewPeopleNumber: '',
          
          newPeopleSendCount: '',
          newPeopleSendMaxCount: '',
          newPeopleSendTotalCount: '',

          boolSignUpSendCount: false, 
          signUpSendCount: '',
          signUpSendMaxCount: '1',

          boolLiveReserveSendCount: false,
          liveReserveSendCount: '',
          liveReserveSendMaxCount: '1',

          boolInternalStaffLimit: false,
          
          lotteryStartDate: '',
          lotteryEndDate: '',
          exchangeEndDate: '',
          activityTotalLotteryCount:'0',

          lotteryMode: 'lottery-9'
        },
        signUpConf: {
          joinPeopleNum: '',
          viewPeopleNum: '',
          
          newNumCustomer: '',
          registNumCustomer: '',
          newNumStore: '',
          registNumStore:'',
          newNumEmployee: '',
          registNumEmployee: '',
          boolShowNotice: true,
          boolDefinitionSignUpSms: false,
          definitionSignUpSms: '',
         
        },
        spikeConf: {
          boolAreaLimited: false,
        }
      },
      // 附加活动配置
      additionalForm: {
        redPacket: {
          boolShowRedPacket: false,
          boolAreaLimited: false,
          boolRedPacketRolling: false,
          boolInternalStaffLimit: false,
          redPacketType: '1',
          singleAmount: '',
          totalAmount: '',
          ranges: [
            {
              startAmount: '',
              endAmount: '',
              percent: ''
            }
          ]
        },
        fission: {
          boolAreaLimited: false,
          boolFissionRewardEnabled: false,
          maxFissionNum: '',
          fissionAmount: '',
          totalAmount: '',
          boolFissionRolling: false,
          boolInternalStaffLimit: false
        },
        ranklist: {
          boolRankList: false,
          showType: '',
          showTypeStr: '',
          boolVirtualData: false,
          virtualPeople: '',
          virtualMoney: '',
          keyId: ''
        }
      },
      // 虚拟数据
      rankData: {},
      // 模板包含的组件列表
      comList: [],
      // 模板信息
      templateInfo: {},
      contentLoading: false,
      // 新创建的活动ID
      activityId: '',
      // 编辑的活动ID
      activityData: {},
      testlist: [],
      isFooter: true,
      stylePageMain: {
        activityId: '',
        loadingPage: {
          activityId: '',
          loadingBackImg: '',
          loadingText: '',
        },
        homePage: {
          activityId: '',
          homeBackImg:'',
          homeTitleImg: '',
          homeBtnImg: '',
          homeVisionImg: '',
          dynamicImgList: [],
        },
        dialoguePage: {
          activityId: '',
          dialogueBackImg: '',
          dialogueAImg: '',
          dialogueBImg: '',
        },
        questionPage: [],
        resultPage: []
      },
    }
  },
  methods: {
    async init() {
      this.showLoading();
      // console.log("克隆活动")
      // 选择模板创建
      if (this.$route.query.tmpId) {
        await this.getTemplateInfo();
      } else if (this.$route.query.activityId) {
        // 克隆保存后，使用新的活动id
        const activityId = this.activityId || this.$route.query.activityId;
        // 克隆或者草稿箱进入
        const activityData = await this.getActivityInfo(activityId);
        if (activityData) {
          this.activityData = activityData;
          // 初始化基本信息
          this.initBasicForm(activityData);
          // 初始化组件
          this.initComponentList(activityData.activityModule || []);
          // 初始化海报
          this.initPosterList(activityData.activityPoster || []);
          // 报名其他配置
          this.initSignUpConf(activityData.activityModule || []);
          // 初始化其他配置：产品介绍
          this.initOtherConf(activityData.activityConfig || []);
          // 初始化红包配置
          this.initRedPacketConf(activityData.activityAppend || []);
          // 虚拟数据
          this.rankData = activityData.virtualDataVO || {}
        }
      }
      this.hideLoading();
    },
    changFoot(parme){
      this.isFooter = parme
    },
    getTemplateInfo() {
      if (!this.$route.query.tmpId) {
        return;
      }
      return this.$api.activityMgmt.getTemplateInfoById(this.$route.query.tmpId)
        .then(({data}) => {
          if (!data.activityTmpModule || !data.activityTmpModule.length) {
            return;
          }
          this.templateInfo = data;
          const comList = [];
          data.activityTmpModule.forEach(item => {
            let formData;
            switch (item.moduleType) {
              case 'picture':
              case 'image-text-detail':
                formData = [];
                break;
              case 'sign-up':
                formData = {
                  boolShowTitle: true,
                  boolShowAmount: true,
                  boolShowUsername: true,
                  boolShowPhone: true,
                  boolShowCode: true,
                  signUpfeeLabel: '',
                  signUpfee: '',
                  signUpType: '1',
                  boolSmsSet: false,
                  smsText: '',
                  customField: []
                };
                break;
              case 'attention': 
                formData = {
                  attentionMsg: ''
                };
                break;
              case 'store':
                formData = {}
                break;
              case 'lottery':
                formData = {
                  prizeList: []
                }
                break;
              case 'live-reserve':
                formData = {
                  liveReserveTime: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                  roomId: '',
                  liveRoomId: '',
                  roomName: ''
                }
                break;
              case 'question':
                formData = {
                  isHaslottery: this.templateInfo.activityTmpModule.some(item => item.moduleType === 'lottery'),
                }
                break;
              case 'spike':
                formData = {
                  spikeSections: [{
                    startTime: '',
                    endTime: '',
                    boolPrePay: '',
                    boolPrePayName: '',
                    boolVerification: 'true',
                    sectionLimit: '',
                    goodsLimit: '',
                    writeOff: '',
                    spikeGoods: [],
                  }]
                }
                break;
              case 'connectPic':
                formData = {
                  isLottery: this.templateInfo.activityTmpModule.some(item => item.moduleType === 'lottery'),
                  backgroundMusicName: '',
                  backgroundMusic: '',
                  connectPicBackground: 'https://img3.quanyou.com.cn/joy/group1/M00/17/51/rB4ChWM2eK2AOGAFAArmhM2si8c128.png',
                  timeLimit: '',
                  challengeLevel: '',
                  connectPic: '',
                  lotteryChanceType: '',
                  sendLotteryTimes: '',
                  connectChanceSendType: 'everyDay',
                  sendConnectTimes: '',
                  signUpSendCount: '',
                }
                break;
              case 'groupBuying' :
                formData = {
                  groupWaitTime: '',
                  boolVerification: 'true',
                  boolAreaLimited: 'false',
                  boolInternalStaffLimit: 'false',
                  activityBuyLimit: '',
                  perGoodsBuyLimit: '',
                  goods:[]
                }
                break
              case 'drawLots':
                formData = {
                  drawLots: [],
                  drawLotsPrizes: [],
                  everyDaySendType: 'everyDay',
                  everyDaySendCount: '',
                  boolNewPeopleSendCount: false,
                  everyTimeNewPeopleNumber: '',
                  newPeopleSendCount: '',
                  newPeopleSendTotalCount: '',
                  boolSignUpSendCount: false,
                  signUpSendCount: '',
                  boolInternalStaffLimit: false,
                  boolAreaLimited: false,
                  backgroundMusic: '',
                  backgroundMusicName: ''
                }
                break
              case 'style':
                formData = {
                  activityId: '',
                  loadingPage: {},
                  homePage: {},
                  dialoguePage: {},
                  questionPage: [],
                  resultPage: []
                }
                break
              case 'countMoney': 
                formData = {
                  countMoneyStartTime: '',
                  countMoneyEndTime: '',
                  exchangeEndDate: '',
                  time: '',
                  backgroundMusic: '',
                  backgroundMusicName: '',
                  awardSet: [],
                  rankingType: [],
                  everyOneMaxWinCount: '1',
                  everyDaySendType: 'everyDay',
                  everyDaySendCount: '1',
                 
                  boolNewPeopleSendCount: false,
                  everyTimeNewPeopleNumber: '',
                  
                  newPeopleSendCount: '',
                  newPeopleSendMaxCount: '',
                  newPeopleSendTotalCount: '',

                  boolSignUpSendCount: false, 
                  signUpSendCount: '',
                  signUpSendMaxCount: '1',

                  boolInternalStaffLimit: false,
                  activityTotalLotteryCount:'0',
                  globalprize: [],
                  officePrize: [],
                  ladderPrize: [],
                  randomPrize: [],
                  encouragePrize: [],
                  rule: [{text: ''}]
                }
                break
              case 'coupon': 
                formData = [{
                  startTime: '',
                  endTime: '',
                  deadline: '',
                  couponTickets: []
                }]
                break
              default:
                break;
            }

            comList.push({
              comId: item.baseModuleId,
              comType: item.moduleType,
              sortNo: item.sortNo,
              formData
            });
          });
          this.comList = comList;
        })
        .catch(err => {
          console.log(err);
        })
    },
    getActivityInfo(activityId) {
      if (!activityId) {
        return;
      }
      return this.$api.activityMgmt.getCloneOrDraftsActivityInfoById(activityId)
        .then(({data}) => {
          if (!data) {
            return;
          }
          return data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 初始化基本信息
    initBasicForm(activityData) {
      const {activityId, activityTitle, startTime, endTime} = activityData;
      this.activityId = activityId;
      this.basicInfoForm = {
        activityTitle,
        startTime,
        endTime
      };
    },
    // 初始化组件列表
    initComponentList(moduleList = []) {
      const comList = [];
      moduleList.forEach(moduleItem => {
        let formData = {};
        switch (moduleItem.moduleType) {
          case 'sign-up':
          case 'attention':
            moduleItem.activityModuleDetail.forEach(item => {
              // boolean类型的必须以bool开头命名
              formData[item.moduleDetailCode] = isString(item.moduleDetailCode) && item.moduleDetailCode.startsWith('bool') 
                ? item.moduleDetailValue === 'true'
                : item.moduleDetailValue;
            })
            if (formData.customFieldStr) {
              formData.customField = JSON.parse(formData.customFieldStr)
            }
            break;
          case 'picture':
          case 'image-text-detail':
            formData = moduleItem.activityModuleDetail.map(item => ({
              moduleDetailId: item.moduleDetailId,
              moduleDetailValue: item.moduleDetailValue,
              detailDataType: item.detailDataType,
              sortNo: item.sortNo,
              remark: item.remark || ''
            }));
            break;
          case 'lottery':
            formData = luckDrawData(moduleItem)
            break
          case 'live-reserve':
            formData = this.initLiveReserveData(moduleItem)
            break
          case 'question':
            formData = this.initLiveReserveData(moduleItem)
            break
          case 'spike':
            formData.spikeSections = initspikeData(moduleItem).spikeSections
            break
          case 'connectPic':
            formData = moduleItem.connectPic
            formData.isLottery = moduleList.some(item => item.moduleType === 'lottery')
            break
          case 'groupBuying':
            formData = initGroupBuyingData(moduleItem,this.isClone).groupBuyingVO
            break
          case 'drawLots':
            formData = this.initDrawLotsData(moduleItem)
            break
          case 'style':
            formData = this.initStyleTestData(moduleItem)
            break
          case 'countMoney': 
            formData = this.initCountMoneyData(moduleItem)
            break
          case 'coupon':
            formData = this.initCouponData(moduleItem.couponSessions)
            break
          default:
            break;
        }
        comList.push({
          comId: moduleItem.moduleId,
          comType: moduleItem.moduleType,
          sortNo: moduleItem.sortNo,
          formData
        });
      });
      this.comList = comList;
    },
    // 初始化海报组件
    initPosterList(posterList = []) {
      // posterList.map(item => item.imgUrl);
      this.otherForm.poster = posterList;
    },
    // 初始化报名其他配置
    initSignUpConf(moduleList) {
      const signUpModule = moduleList.find(item => item.moduleType === 'sign-up');
      if (signUpModule) {
        const signUpConf = {};
        signUpModule.activityModuleSetup.forEach(item => {
          // boolean类型的必须以is开头命名
          signUpConf[item.setupColumn] = isString(item.setupColumn) && item.setupColumn.startsWith('bool') 
            ? item.setupColumnValue === 'true'
            : item.setupColumnValue;
        });
        this.otherForm.signUpConf = signUpConf;
      }
      // 抽奖其他配置
      const lotteryModule = moduleList.find(item => item.moduleType === 'lottery');
      if (lotteryModule) {
        this.otherForm.luckDraw = formatDataLottery(lotteryModule.activityModuleSetup)
      }
      // 秒杀其他配置
      const spikeModule = moduleList.find(item => item.moduleType === 'spike');
      if (spikeModule) {
        this.otherForm.spikeConf = formatDataLottery(spikeModule.activityModuleSetup)
      }

    },
    // 初始化直播组件 问答组件
    initLiveReserveData(moduleItem) {
      let formData = {}
      moduleItem.activityModuleDetail.forEach(item => {
        formData[item.moduleDetailCode] = item.moduleDetailValue
      })
      return formData
    },

    // 初始化其他配置
    initOtherConf(confList) {
      const configForm = {};
      confList.forEach(item => {
        // boolean类型的必须以is开头命名
        configForm[item.configCode] = isString(item.configCode) && item.configCode.startsWith('bool') 
          ? item.configValue === 'true'
          : item.configValue;
      });
      this.otherForm.introduction = configForm;

    },
    // 初始化红包/裂变配置
    initRedPacketConf(additionalList) {
      this.additionalForm.redPacket = this.initRedPacketForm(additionalList);
      this.additionalForm.fission = initFissionForm(additionalList, 'fission')
      this.additionalForm.ranklist = initFissionForm(additionalList, 'rankList')
      
    },
    initDrawLotsData(moduleItem) {
      for(let [key,value] of Object.entries(moduleItem.drawLotsMain)) {
        if (key.startsWith('bool') && value != '') {
          moduleItem.drawLotsMain[key] = JSON.parse(value)
        }
      }
      if (this.isClone) {
        moduleItem.activityId = ''
        moduleItem.status = 0
        moduleItem.drawLotsMain.activityId = ''
        moduleItem.drawLotsMain.status = 0
        moduleItem.drawLotsMain.id =  ''
        moduleItem.drawLotsMain.isClone = true
        moduleItem.drawLotsMain.drawLots.forEach(item => {
          item.id = '',
          item.activityId = ''
          item.status = 0
        })
        moduleItem.drawLotsMain.drawLotsPrizes.forEach(item => {
          item.id = '',
          item.activityId = ''
          item.status = 0
        })
      }
      return moduleItem.drawLotsMain
    },
    initStyleTestData(moduleItem) {
      if (this.isClone) {
        moduleItem.activityId = ''
        moduleItem.stylePageMain.activityId = ''
      }
      return moduleItem.stylePageMain
    },
    initCountMoneyData(moduleItem) {
      let initArr= ['globalprize','officePrize','ladderPrize','randomPrize','encouragePrize']
      let fieldS = ['awardSet','rankingType','rule']
      let formDate = moduleItem.gameModule
      
      for (let [key,value] of Object.entries(formDate)) {
        // "true" => true  "[]"=>[]
        if ((value && key.startsWith('bool') || fieldS.includes(key))) {
          formDate[key] = JSON.parse(value)
        }
        // globalprize=null => globalprize=[]
        if (initArr.includes(key) && !value) {
          formDate[key] = []
        }
      }
      if (this.isClone) {
        moduleItem.activityId = ''
        formDate.activityId = ''
        formDate.id = ''
        initArr.forEach(field => {
          (formDate[field] || []).forEach(item => {
            item.id = ''
            item.activityId = ''
          })
        })
        // 不是新角色清空排行榜数据
        if (!this.userInfo.countAuthority) {
          formDate.rankingType = []
          formDate.globalprize = []
          formDate.officePrize = []
          let index = formDate.awardSet.findIndex(item => item=='ranking')
          if (index !== -1) {
            formDate.awardSet.splice(index,1)
          }
        }
      }
      return formDate
    },
    initCouponData(couponSessions) {
      if (!this.isClone) {
        couponSessions.forEach(item => {
          delete item.sessionId
          delete item.activityId
          item.couponTickets.forEach(childeItem => {
            delete childeItem.sessionId
            delete childeItem.activityId
            delete childeItem.couponId
          })
        })
      }
      return couponSessions

    },
    async nextStep() {
      if (!this.checkValid()) {
        return;
      }
      // 报名字段验证
      if (this.isHasSignUp){
        let isPass = true
        this.comList.forEach(item => {
          if (item.comType == 'sign-up') {
            item.formData.customFieldStr = JSON.stringify(item.formData.customField)
            if (item.formData.boolSmsSet && this.isTeacher) {
              if (item.formData.smsText == '') {
                this.$toast('请输入报名成功的短信内容')
                isPass = false
                return
              }
            }
            let fieldIsPass = item.formData.customField.every(fieldItem => fieldItem.fieldKey != '')
            if (!fieldIsPass) {
              this.$toast('请输入报名自定义字段')
              isPass = false
            }
          }
        })
        if (!isPass) {
          return
        }
      }
      // 抽奖必填项验证
      const isAdopt = formValidation(this.comList)
      if (!isAdopt) {
        this.$notify({
          message: `请完善抽奖配置`,
          type: 'warning'
        });
        return
      }
      // 问答必填项验证
      if (this.$refs.question) {
        const verification = await this.$refs.question[0].onFailed().catch(_=>(console.log(_)))
        if (!verification) {
          return 
        }
      }
      // 秒杀参数验证
      if (this.isSpike) {
        const {isAdopt,title} = paramesVerification(this.comList, 'spike')
        if (!isAdopt) {
          this.$toast(title)
          return
        }else {
          const data =  spikeTimeVerification(this.comList, 'spike', this.basicInfoForm)
          if (!data.timeAdopt) {
            this.$toast(data.title)
            return
          }
        }
      }

      // 拼图参数验证
      if (this.isConnectPic) {
        const isAdopt = connectPicVerification(this.comList)
        if (!isAdopt) {
          this.$notify({
            message: `请完善拼图设置`,
            type: 'warning'
          });
          return
        }
      }
      // 拼团参数验证
      if (this.isGroupBuying) {
        let isAdopt = await this.$refs.groupBuying[0].submit().catch(_=>(console.log(_)))
        if (!isAdopt) {
          return
        }
      }
      // 求签验证
      if (this.isDrawLots) {
        if (!this.$refs.drawLots[0].verifyDrawLots()) {
          return
        }
      }
      // 风格测试参数验证
      if (this.$refs.style) {
        if (!this.$refs.style[0].verifyParames()) {
          return
        }
      }
      // 红包挑战赛参数校验
      if (this.$refs.countMoney) {
        await this.$refs.countMoney[0].verifyParames()
      }

      if (this.$refs.coupon) {
       const isPass = await this.$refs.coupon[0].verifyParames()
       if (!isPass) return
      }
      this.stepNum ++;
      this.scrollToTop();
    },
    preStep() {
      this.stepNum --;
      this.scrollToTop();
    },
    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.scrollBox && this.$refs.scrollBox.scrollTo(0, 0)
      });
    },
    // 注意事项参数, 图片，图文详情参数
    getComponentDTO(moduleItem, isImage) {
      const fields = [];
      const formData = moduleItem.formData;
      if (isImage && Array.isArray(formData)) {
        formData.forEach(item => {
          fields.push({...item});
        });
      } else {
        for (const [key, value] of Object.entries(formData)) {
          fields.push({
            moduleDetailCode: key,
            moduleDetailValue: value
          });
        }
      }

      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields
      };
    },
    // 报名，
    getSignUpDTO(moduleItem) {
      const fields1 = [];
      const fields2 = [];
      for (const [key, value] of Object.entries(moduleItem.formData)) {
        if (key != 'customField') {
          fields1.push({
            moduleDetailCode: key,
            moduleDetailValue: value
          });
        }
       
      }
      for (const [key, value] of Object.entries(this.otherForm.signUpConf)) {
        fields2.push({
          setupColumn: key,
          setupColumnValue: value
        });
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: 'sign-up',
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields1,
        activityModuleSetup: fields2
      };
    },
    getOtherConfDTO(comType) {
      const fields = [];
      for (const [key, value] of Object.entries(this.otherForm[comType])) {
        fields.push({
          configCode: key,
          configValue: value
        });
      }
      return fields;
    },
    checkValid() {
      // 基础信息
      const basicInfoRef = this.$refs.basicInfoRef;
      if (basicInfoRef && !basicInfoRef.checkValid()) {
        return false;
      }

      // 附加活动：红包
      const redPacketRef = this.$refs.redPacketRef;
      if (redPacketRef && !redPacketRef.checkValid()) {
        return false;
      }
      const lotteryConfRef = this.$refs.lotteryConfRef
      if (lotteryConfRef && !lotteryConfRef.checkValid()){
        return false
      }

      return true;
    },
    // 抽奖组件
    getLiveReserveDTO(moduleItem) {
      const fields1 = [];
      const fields2 = [];
      moduleItem.formData.prizeList.forEach(item => {
        let discharge = ['moduleGroupCode','isNewAdd','fieldId','isReplace']
        for(let [key, value] of Object.entries(item)) {
          if (!discharge.includes(key)) {
            fields1.push({
              moduleDetailCode: key,
              moduleDetailValue: key == 'bakImg' && item[key].length ? item[key][0].url :  value ? value.toString() : '',
              moduleGroupCode: item.moduleGroupCode
            })
          }
        }
      })
      for (const [key, value] of Object.entries(this.otherForm.luckDraw)) {
        fields2.push({
          setupColumn: key,
          setupColumnValue: value
        });
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields1,
        activityModuleSetup: fields2
      };
    },
    // 直播组件 问答
    liveDataFormat(moduleItem) {
      const fields = []
      for(let [key,value] of Object.entries(moduleItem.formData)) {
        fields.push({
          moduleDetailValue: value,
          moduleDetailCode: key,
        })
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        activityModuleDetail: fields,
      }
    },
    spikeDataFormat(moduleItem) {
      moduleItem.formData.spikeSections.forEach(spikeSectionsItem => {
        if (spikeSectionsItem.spikeGoods) {
          spikeSectionsItem.spikeGoods.forEach(spikeGoodsItem => {
            spikeGoodsItem.headImg = spikeGoodsItem.headImgList[0].url
            if (spikeGoodsItem.detailsImg.length) {
              let detailsImg = []
              spikeGoodsItem.detailsImg.forEach(imgItem => {
                detailsImg.push(imgItem.url)
              })
              spikeGoodsItem.goodsDetails = detailsImg
            }else {
               spikeGoodsItem.goodsDetails = []
            }
          })
        }
      })
      let fields2 = []
      for (const [key, value] of Object.entries(this.otherForm.spikeConf)) {
        fields2.push({
          setupColumn: key,
          setupColumnValue: value
        });
      }
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        spikeSections: moduleItem.formData.spikeSections,
        activityModuleSetup: fields2
      }
    },
    // 拼图
    connectPicFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        connectPic: moduleItem.formData,
      }
    },
    // 拼团
    groupBuyingFormat(moduleItem) {
      moduleItem.formData.goods.forEach(item => {
        item.headImg = item.headImgList[0].url
        if (item.detailsImg.length) {
          let goodsDetails = []
          item.detailsImg.forEach(imgItem => {
            goodsDetails.push(imgItem.url)
          })
           item.goodsDetails = goodsDetails
        }else {
          item.goodsDetails = []
        }
      })
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        groupBuying: moduleItem.formData,
      }
    },
    // 求签
    drawLotsFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        drawLotsMain: moduleItem.formData,
      }
    },
    // 风格测试
    styleTestFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        stylePageMain: moduleItem.formData,
      }
    },
    // 红包挑战赛
    countMoneyFormat(moduleItem) {
      let fieldS = ['awardSet','rankingType','rule']
      let prizeTypeAll = ['ladder','random','encourage','global','office']
      let newFormData = _.cloneDeep(moduleItem.formData)

      // 当奖励设置没选择时，清空对应的数组
      let { awardSet,rankingType } = newFormData
      if (!awardSet.includes('ranking')) rankingType = []
      let prizeType = awardSet.concat(rankingType)
      prizeTypeAll.forEach(item => {
        if (!prizeType.includes(item)){
          if (item == 'global') {
            newFormData.globalprize = []
          } else {
            newFormData[`${item}Prize`] = []
          }
        }
      })

      for (let [key,value] of Object.entries(newFormData)) {
        if ((value && fieldS.includes(key))) {
          newFormData[key] = JSON.stringify(value)
        }
      }
  
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        gameModule: newFormData,
      }
    },
    // 优惠券组件
    couponFormat(moduleItem) {
      return {
        moduleId: moduleItem.comId,
        moduleType: moduleItem.comType,
        sortNo: moduleItem.sortNo,
        couponSessions: moduleItem.formData,
      }
    },
    buildParams(optType) {
      const activityModule = [];
      this.comList.forEach(item => {
        switch (item.comType) {
          case 'sign-up':
            activityModule.push(this.getSignUpDTO(item));
            break;
          case 'store':
          case 'attention':
            activityModule.push(this.getComponentDTO(item));
            break;
          case 'picture':
          case 'image-text-detail':
            activityModule.push(this.getComponentDTO(item, true));
            break;
          case 'lottery':
            activityModule.push(this.getLiveReserveDTO(item, true));
            break;
          case 'live-reserve':
            activityModule.push(this.liveDataFormat(item, true));
            break;
          case 'question':
            activityModule.push(this.liveDataFormat(item, true));
            break;
          case 'spike':
            activityModule.push(this.spikeDataFormat(item, true));
            break;
          case 'connectPic':
            activityModule.push(this.connectPicFormat(item, true));
            break;
          case 'groupBuying':
            activityModule.push(this.groupBuyingFormat(item, true));
            break;
          case 'drawLots': 
            activityModule.push(this.drawLotsFormat(item));
            break
          case 'style': 
            activityModule.push(this.styleTestFormat(item)); 
            break
          case 'countMoney': 
            activityModule.push(this.countMoneyFormat(item)); 
            break
          case 'coupon': 
            activityModule.push(this.couponFormat(item)); 
            break
          default:
            break;
        }
      });

      const activityPoster = this.otherForm.poster.map((item, index) => {
        return {
          imgUrl: item.imgUrl,
          sortNo: index
        };
      })

      const activityConfig = [];
      activityConfig.push(...this.getOtherConfDTO('introduction'));

      const activityAppend = [];
      // 红包
      activityAppend.push({
        appendName: 'redPacket',
        activityAppendElement: this.getRedPacketDTO(this.additionalForm.redPacket)
      });
      // 裂变佣金
      activityAppend.push({
        appendName: 'fission',
        activityAppendElement: getFissionDTO(this.additionalForm.fission)
      });
      // 排行榜
      activityAppend.push({
        appendName: 'rankList',
        activityAppendElement: getFissionDTO(this.additionalForm.ranklist)
      });

      const params = {
        flag: this.is365 ? 2: 1,
        activityId: (this.isClone || !this.activityId) ? '' : this.activityId,
        resourceActivityId: this.isClone ? this.activityId : '',
        isClone: this.isClone ? 1 : 0,
        tmpId: this.isClone || !this.templateInfo.tmpId ? this.activityData.tmpId : this.templateInfo.tmpId ,
        optType,
        ...this.basicInfoForm,
        // 组件
        activityModule,
        // 海报
        activityPoster,
        // 活动配置
        activityConfig,
        // 附加活动
        activityAppend
      };
      return params;
    },
    async saveActivity(optType) {
      if (!this.checkValid()) {
        return;
      }
      if (this.isHasSignUp){
        let isPass = true
        this.comList.forEach(item => {
          if (item.comType == 'sign-up') {
            item.formData.customFieldStr = JSON.stringify(item.formData.customField)
            // 开启报名成功短信并且是活动老师身份
            if (item.formData.boolSmsSet && this.isTeacher) {
              if (item.formData.smsText == '') {
                this.$toast('请输入报名成功的短信内容')
                isPass = false
                return
              }
            }else {
              item.formData.boolSmsSet = false
              item.formData.smsText = ''
            }
            let fieldIsPass = item.formData.customField.every(fieldItem => fieldItem.fieldKey != '')
            if (!fieldIsPass) {
              this.$toast('请输入报名自定义字段')
              isPass = false
            }
          }
        })
        if (!isPass) {
          return
        }
      }
      // 问答必填项验证
      if (this.$refs.question) {
        const verification = await this.$refs.question[0].onFailed(this.activityId).catch(_=>(console.log(_)))
        if (!verification) {
          return 
        }
      }
      // 秒杀参数验证
      if (this.isSpike) {
        const {isAdopt, title} = paramesVerification(this.comList, 'spike')
        if (!isAdopt) {
          this.$toast(title)
          return
        }else {
          const data = spikeTimeVerification(this.comList, 'spike', this.basicInfoForm)
          if (!data.timeAdopt) {
            this.$toast(data.title)
            return
          }
        }
      }
      // 抽奖必填项验证
      const isAdopt =  formValidation(this.comList)
      if (!isAdopt) {
        this.$notify({
          message: `请完善抽奖配置`,
          type: 'warning'
        });
        return
      }
       // 拼图参数验证
      if (this.isConnectPic) {
        const isAdopt = connectPicVerification(this.comList)
        if (!isAdopt) {
          this.$notify({
            message: `请完善拼图设置`,
            type: 'warning'
          });
          return
        }
      }
      // 拼团参数验证
      if (this.isGroupBuying) {
        let isAdopt = await this.$refs.groupBuying[0].submit().catch(_=>(console.log(_)))
        if (!isAdopt) {
          return
        }
      }
      // 求签参数验证
      if (this.isDrawLots) {
        if (!this.$refs.drawLots[0].verifyDrawLots()) {
          return
        }
      }
      // 风格测试参数验证
      if (this.$refs.style) {
        if (!this.$refs.style[0].verifyParames()) {
          return
        }
      }

      // 红包挑战赛参数校验
      if (this.$refs.countMoney) {
        await this.$refs.countMoney[0].verifyParames()
      }

      // 排行榜验证
      const isPass = await this.$refs.rankListRef.onFailed().catch(_ =>(console.log(_)))
      if (!isPass) return
      this.showLoading();
      const saveResult = await this.$api.activityMgmt.saveActivity(this.buildParams(optType))
        .catch(err => {
          console.log(err);
          return
        });
      if (!saveResult) {
        this.hideLoading();
        return
      }
     
      const {activityId, wxPayOrderResult,orderNo} = saveResult.data;
      this.activityId = activityId;
      this.hideLoading();
      // 保存
      if (optType == 1) {
        this.$toast('保存成功');
        // 克隆保存后，使用新的活动id
        // if (this.isClone) {
        //   this.$router.replace({
        //     path: '/activity/edit',
        //     query: {
        //       activityId: this.activityId
        //     }
        //   });
        // }
        this.$router.replace({
          path: '/home',
        });
      } else if (optType == 2) {
        // 保存并发布
        // 如果需要支付，调用微信支付
        if (orderNo) {
          saveResult.data.source = 'activity'
          await wxPay(saveResult.data)
            .then(_ => {
              this.release(activityId, '');
            }).catch(err => {
              if (this.isClone) {
                this.isClone = false
                // 刷新问答组件
                if (this.$refs.question) {
                  this.$refs.question[0].init(this.activityId)
                }
              }
            })
        } else {
          this.release(activityId);
        }
      }
    },
    // 发布
    release(activityId, orderNo) {
      const params = {
        activityId, 
        orderNo
      };
      return this.$api.activityMgmt.releaseActivity(params)
        .then(_ => {
          this.$toast('发布成功');
          this.$router.replace({
            path: '/home',
          });
        })
        .catch(
          err => {
            // 是克隆活动的情况下，保存成功，发布失败，再次发布需要携带活动id
            if (this.isClone) {
              this.isClone = false
              // 刷新问答组件
              if (this.$refs.question) {
                this.$refs.question[0].init(this.activityId)
              }
            }
          }
        );
    },
    preview() {
      const activityId = this.activityId || undefined
      // 将活动数据存入vuex
      if (!activityId) {
        this.$store.commit('cacheCreateParam', this.buildParams(1));
      }

      this.$router.push({
        path: '/activity-home',
        query: {
          isPreview: 1,
          activityId
        }
      })
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.main
  .scroll-box
    height: calc(100vh - 64px)
    overflow-y auto
    &::-webkit-scrollbar
      display: none

  // main
  //   padding-bottom 64px
  .loading-box
    display: flex
    justify-content: center
    align-items: center
    height 50vh
    
  .footer
    box-sizing: border-box
    position fixed
    left 0
    bottom 0
    // z-index 999
    padding 0 10px
    height 64px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    background-color #fff

    .footer-btn
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    .footer-btn-s
      padding 10px 15px
    .plain
      color $mainTextColor
      background-color: #fff

</style>
